//
//
//
//
//
//
//
//
//
//
//
//

import EditScale from './EditScale.vue'
export default {
  props: {
    desc: {
      type: String,
      default: '',
    },
    question: {
      type: Object,
      default: {},
    },
    src: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    blankVisible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  components: {
    EditScale,
  },
  data() {
    return {}
  },
  methods: {},
}
